import { CatalogPage } from '@/catalog/CatalogPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/$')({
  component: CatalogPage,
})
